// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__4JEzr","selected":"Chip_selected__26xGe"};